import { render, staticRenderFns } from "./GlobalLoading.vue?vue&type=template&id=0c43573e&"
import script from "./GlobalLoading.vue?vue&type=script&lang=ts&"
export * from "./GlobalLoading.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalLoading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports